module.exports = __webpack_public_path__ + "static/media/Diamond.3cbbd2c8.svg";